import { dispatchX } from "@my-dld/utils/StoreUtils";
import { EjariDataAction } from "@eres/ejari-core/reducers/EjariData";
import { EjariApi } from "@eres/ejari-api";
import { Store } from "redux";
import { AppReducer } from "@10x/coreapp";
import { getSafePropertyIdForDetails } from "@eres/ejari-api/Utils";

export function UpdateProperty( store: Store<AppReducer>, delay: number = 1000 ) {
	const cp = store.getState().EjariData.property;
	if ( cp ) {
		dispatchX( { type: EjariDataAction.EJARI_UPDATE_STATE, payload: { isRefreshing: true } } );
		setTimeout( () => {
			EjariApi.getPropertyDetail( getSafePropertyIdForDetails( cp ), cp.IsFreeHold, cp.PropertyTypeId )
			.then( p => {
				dispatchX( {
					type: EjariDataAction.EJARI_UPDATE_STATE, payload: {
						property: p,
						isRefreshing: false
					}
				} );
			} ).catch( e => {
				dispatchX( { type: EjariDataAction.EJARI_UPDATE_STATE, payload: { isRefreshing: false } } );
			} );
		}, delay );

	}
}
